import { Box, makeStyles, useTheme } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import React from "react";
import { Theme } from "../.themes";
import CompositionBox from "./CompositionBox";
import DynamicDivider from "./DynamicDivider";

const useStyles = makeStyles((theme: Theme) => ({
  header: {
    backgroundColor: theme.palette.backgroundSecondary?.default,
    textAlign: "center",
    padding: `${theme.spacing(3)}px 0`,
    "& hr": {
      border: "none",
      width: "75px",
      backgroundColor: "transparent",
      margin: 0,
    },
    display: "flex",
    flexDirection: "column",
    minHeight: "216px",
    ...theme.header,
  },
  headerText: {
    ...theme.skeletonHeaderText,
  },
  divider: {
    margin: "2rem auto",
    ...theme.divider,
  },
  text: {
    marginTop: "12px",
  },
  info: {
    marginTop: "16px",
  },
  toggleButton: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: "8px",
  },
  button: {
    background: theme.palette.primary.main,
    maxWidth: "384px",
    width: "100%",
  },
  rect: {
    marginTop: "8px",
    maxWidth: "384px",
    width: "100%",
  },
  option: {
    width: "184px",
    [theme.breakpoints.down("sm")]: {
      width: "163px",
    },
  },
  addon: {
    maxWidth: "380px",
    width: "100%",
    marginBottom: "16px",
  },
  addons: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: "16px",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },
  },
}));

const FirstPageSkeleton: React.FC<{}> = () => {
  const theme: Theme = useTheme();
  const classes = useStyles(theme);

  return (
    <Box>
      <div className={classes.header}>
        <CompositionBox maxWidth={250}>
          <Box className='welcome-box-labels'>
            <Skeleton variant='text' height='40px' width='250px' className={classes.headerText} />
            <Skeleton variant='text' height='40px' width='250px' className={classes.headerText} />
          </Box>
        </CompositionBox>
        <hr />
        <CompositionBox maxWidth={150} className={classes.info}>
          <Box className='welcome-box-labels'>
            <Skeleton variant='text' height='20px' width='150px' className={classes.headerText} />
            <Skeleton variant='text' height='20px' width='150px' className={classes.headerText} />
          </Box>
        </CompositionBox>
      </div>
      <CompositionBox maxWidth={250}>
        <Box className='welcome-box-labels'>
          <Skeleton variant='text' height='40px' width='250px' className={classes.text} />
        </Box>
      </CompositionBox>
      <Box className={classes.text}>
        <CompositionBox maxWidth={384}>
          <Skeleton variant='text' height='20px' width='250px' />
          <Skeleton variant='rect' height='52px' className={classes.rect} />
        </CompositionBox>
      </Box>
      <Box className={classes.text}>
        <CompositionBox maxWidth={384}>
          <Skeleton variant='text' height='20px' width='190px' />
          <div className={classes.toggleButton}>
            <Skeleton variant='rect' height='52px' className={classes.option} />
            <Skeleton variant='rect' height='52px' className={classes.option} />
          </div>
        </CompositionBox>
      </Box>
      <DynamicDivider maxWidth={1200} className={classes.divider} />
      <CompositionBox maxWidth={250}>
        <Box className='welcome-box-labels'>
          <Skeleton variant='text' height='40px' width='250px' className={classes.text} />
        </Box>
      </CompositionBox>
      <Box className={classes.text}>
        <CompositionBox maxWidth={814}>
          <Skeleton variant='rect' height='104px' />
          <Skeleton variant='rect' height='490px' className={classes.info} />
        </CompositionBox>
      </Box>
      <DynamicDivider maxWidth={1200} className={classes.divider} />
      <CompositionBox maxWidth={250}>
        <Box className='welcome-box-labels'>
          <Skeleton variant='text' height='40px' width='250px' className={classes.text} />
        </Box>
      </CompositionBox>
      <Box>
        <CompositionBox maxWidth={1200}>
          <Box className={classes.addons}>
            <Skeleton variant='rect' height='265px' className={classes.addon} />
            <Skeleton variant='rect' height='265px' className={classes.addon} />
            <Skeleton variant='rect' height='265px' className={classes.addon} />
          </Box>
        </CompositionBox>
      </Box>
      <DynamicDivider maxWidth={1200} className={classes.divider} />
      <Box>
        <CompositionBox maxWidth={384}>
          <Skeleton variant='rect' height='52px' className={classes.button} />
        </CompositionBox>
      </Box>
    </Box>
  );
};

export default FirstPageSkeleton;
